export const toIsoFromDateTimeParts = (date: string, time: string, withTimezone?: boolean) => {
  const hasSlash = date.includes("/");
  let yyyy = "", mm = "", dd = "";

  if (hasSlash) {
    const [d, m, y] = date.split("/");
    dd = d; mm = m; yyyy = y;
  } else {
    const [y, m, d] = date.split("-");
    dd = d; mm = m; yyyy = y;
  }

  const base = `${yyyy}-${mm}-${dd}T${time}:00`;

  if (!withTimezone) return base;

  const offsetMinutes = new Date().getTimezoneOffset();
  const sign = offsetMinutes <= 0 ? '+' : '-';
  const absMinutes = Math.abs(offsetMinutes);
  const hours = String(Math.floor(absMinutes / 60)).padStart(2, '0');
  const minutes = String(absMinutes % 60).padStart(2, '0');

  return `${base}${sign}${hours}:${minutes}`;
};

export const getUserTimezoneFormatted = () => {
  const parts = new Intl.DateTimeFormat('pt-BR', { timeZoneName: 'long' }).formatToParts(new Date());
  const offsetParts = new Intl.DateTimeFormat('pt-BR', { timeZoneName: 'shortOffset' }).formatToParts(new Date());

  const name = parts.find(p => p.type === 'timeZoneName')?.value ?? '';
  const offset = offsetParts.find(p => p.type === 'timeZoneName')?.value ?? '';

  return offset ? `${name} (${offset})` : name;
};
